






























































import Vue from 'vue';
import { Resolve } from 'vue-di';
import { Component, Prop } from 'vue-property-decorator';
import EnrollmentModule from '~/store/enrollment';
import LayoutModule from '~/store/layout';

@Component<Footer>({})
export default class Footer extends Vue {
  @Resolve
  public layout!: LayoutModule;

  @Resolve
  public enrollment!: EnrollmentModule;

  @Prop()
  public brkPoints!: object;

  public get genzymeLogoSrc() {
    return this.$settings.url(this.$settings.genzymeLogo);
  }



  public checkIfNonDrugPath() {
    if (this.$route.name === 'index' || this.$route.name === 'selection' || this.$route.name === 'reimbursement') {
      return true;
    } else {
      return false;
    }
  }
  public dynamicStyleFooterLogo() {
    if (this.checkIfNonDrugPath()) {
      return {
        position: 'relative',
        top: '-20%',
      };
    } else {
      return {};
    }
  }


}
